export const uiTokens = {
  brand: {
    blue: '#3139FB',
    pink: '#FF30AF',
    pinkDark: '#EE1D9E',
  },
} as const;

export const mantineColors = {
  brandBlue: [
    '#F3F4FF',
    '#E4E6FF',
    '#CDD0FF',
    '#AFB3FF',
    '#9095FF',
    '#7177FF',
    uiTokens.brand.blue,
    '#2D33D6',
    '#252AAE',
    '#1D218A',
  ],
  brandPink: [
    '#FFF0FA',
    '#FFE0F4',
    '#FFC5E7',
    '#FFA0D4',
    '#FF78C0',
    uiTokens.brand.pink,
    '#DF178E',
    '#B80E72',
    '#92085A',
    '#700344',
  ],
  neutral: [
    '#F8FAFC',
    '#F1F5F9',
    '#E2E8F0',
    '#CBD5E1',
    '#94A3B8',
    '#64748B',
    '#475569',
    '#334155',
    '#1E293B',
    '#0F172A',
  ],
} as const;
